<template>
  <b-card no-body class="cards card-box">
    <div class="table-responsive">
      <b-table @row-dblclicked="editar" head-variant="dark" hover :items="items" :fields="campos">
        <template v-slot:cell(baixar)="item">
          <div class="d-flex">
            <b-button variant="flat-primary" @click="editar(item.item)" v-if="permissao.u">
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button variant="flat-info" @click="baixarArquivo(item.item.id)" v-if="permissao.r">
              <i class="fa-solid fa-cloud-arrow-down"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import DocumentosService from "@/common/services/documentos/documentos.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from '@/common/utils/helpers';
import Swal from "sweetalert2";

export default {
  name: "Documentos",


  data() {
    return {
      idModal: "modal-acesso",
      titleModal: "Acesso",
      empresaSelecionada: null,
      campos: [
        {
          key: "especificacao",
          label: this.$t("TABELA_DOCUMENTOS.ESPECIFICACOES"),
        },
        {
          key: "nomeArquivoAWS",
          label: this.$t("TABELA_DOCUMENTOS.NOME_ARQUIVO"),
        },
        {
          key: "descricao",
          label: this.$t("TABELA_DOCUMENTOS.DESCRICAO"),
        },
        {
          key: "detalhamento",
          label: this.$t("TABELA_DOCUMENTOS.DETALHAMENTO"),
        },
        {
          key: "baixar",
          label: "Ações",
        },
      ],
      items: [],
      totalRows: 5,
      empresas: [],
      usuarioId: null,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: this.$t("GERAL.PAGINACAO") }],

      
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "Modelos de documentos" }]);
    this.listar();
  },

  methods: {

   
    listar() {
      if(!this.selectedCompany)
                return;
      this.$store.dispatch(START_LOADING);
      DocumentosService.listar(this.selectedCompany.id)
        .then((result) => {
          result.data.data.itens.sort((a, b) => a.especificacao.localeCompare(b.especificacao));
          let data = result.data.data.itens;
          this.items = data;

          this.totalRows = result.data.data.paginacao.totalDeElementos / this.perPage;
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    baixarArquivo(arquivoId){
      this.$store.dispatch(START_LOADING);

      DocumentosService.downloadArquivo(arquivoId)
      .then(response => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");               
      }).catch(err => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
      }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
      });
    },

    editar: function(item){
      this.$router.push({ name: "documentos-formulario", params: { id: item.id } });
    },
    
  },
  computed : {
    permissao() {
      return this.$store.getters['app/retornaPermissao']('ModelosDocumentos');
    },     
    selectedCompany() {
        return this.$store.state.app.selectedCompanyObj;
    },
  }
    
};
</script>
